import { render, staticRenderFns } from "./AddStoreDialog.vue?vue&type=template&id=15b6256f"
import script from "./AddStoreDialog.vue?vue&type=script&lang=js"
export * from "./AddStoreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports